
import { mapState, mapMutations } from 'vuex';
import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';

const namespace: string = 'app';

@Component({
})

export default class ApiError extends Vue {
  @State('apiError', { namespace }) public apiError!: any;
  @Action('resetApiError', { namespace }) public resetApiError: any;
}
